import type { GetStaticProps } from "next"
import { type Metadata, PageMeta } from "@/components/resources/components/Seo/PageMeta"
import { getNewsletterTeasers } from "@/components/resources/data/beehiiv/teasers"
import { byNewest } from "@/components/resources/data/markdown/posts"
import type { CategoryType, Teaser } from "@/components/resources/data/posts.types"
import { SiteLayout } from "@/components/resources/layouts/site"
import { CategoryArchive } from "@/components/resources/templates/CategoryArchive"

interface Props {
  entries: Teaser[]
  title: string
  lead: string
  category: CategoryType
  meta: Metadata
}

const Archive = ({ entries, title, lead, category, meta }: Props) => {
  return (
    <>
      <PageMeta meta={meta} />
      <CategoryArchive entries={entries} category={category} title={title} lead={lead} />
    </>
  )
}
Archive.getLayout = SiteLayout

export default Archive

export const getStaticProps: GetStaticProps<Props> = async () => {
  return {
    props: {
      entries: (await getNewsletterTeasers()).sort(byNewest),
      title: "Newsletter",
      lead: "Our weekly Beehiiv newsletter",
      category: "newsletter" as const,
      meta: {
        title: "Newsletter",
        description: "Newsletter description",
        canonical: null,
        image: null,
        url: null,
        noIndex: false,
      },
    },
    revalidate: 180,
  }
}
